<template>
	<section id="colecoes">
		<container>
			<div class="search-box">
				<span class="filter"><i class="fas fa-filter"></i> Filtros:</span>
				<div class="section-box">
					<div class="search-section">
						<label for="search"><i class="fas fa-search"></i></label>
						<input id="search" type="text" placeholder="Filtre pela coleção ou usuário" v-model.lazy="params.termo" @keyup.enter="getPaginaAtual" />
					</div>
					<ButtonAction :onClick="getPaginaAtual"><span class="txt">FILTRAR</span></ButtonAction>
				</div>
			</div>
			<load-content v-if="loadContent" />
			<div class="table-wrapper" v-if="colecoes.length > 0">
				<div class="table">
					<table>
						<thead>
							<tr>
								<th>Nome</th>
								<th>Criado Por</th>
								<th>Data de modificação</th>
								<th>Ações</th>
							</tr>
						</thead>

						<tbody>
							<tr class="fields" v-for="(colecao, index) in colecoes" :key="index">
								<td><span>{{ colecao.nome }}</span></td>
								<td><span>{{ colecao.autor }}</span></td>
								<td><span>{{ colecao.dtUpdate }}</span></td>
								<td class="acoes">
									<router-link :to="{ name: 'colecaoView', params: { id: colecao.id, botao: '/colecoes' }}">
										<button-action type="button" style="margin-right: 5px;"><i class="far fa-eye"></i></button-action>
									</router-link>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
					<div class="paginacao" v-if="totalItens > 20">
						<Pagination :totalItens="totalItens" :currentPage="paginaAtual" @pagina="getPaginaAtual" />
					</div>
			</div>
			<div v-else-if="inicial" class="not-found">
					Não existe nenhuma coleção :)
			</div>
		</container>
	</section>
</template>

<script>
import ButtonAction from '@/components/shared/ButtonAction'
import container from '@/components/shared/Container'

import Pagination from '@/components/shared/Pagination'
import LoadContent from '@/components/shared/LoadContent'
import { colecoes } from '@/services/colecoes'
export default {
	components: { container, ButtonAction, Pagination, LoadContent },
	data () {
		return {
			params: {
				onlyRoot: true,
				nome: ''
			},
			colecoes: [],
			inicial: false,
			paginaAtual: 1,
			loadContent: true,
			totalItens: 20
		}
	},
	async created () {
		this.getPaginaAtual()
	},
	methods: {
		async getPaginaAtual () {
			this.params = {
				...this.params,
				...this.$route.query
			}

			if (this.params && this.params.skip) {
				this.paginaAtual = parseInt(this.params.skip)
				this.params.skip = parseInt(this.params.skip) - 1
			} else {
				this.paginaAtual = 1
				this.params.skip = 0
			}

			this.colecoes = []
			await colecoes.find(this.params)
				.then(res => {
					this.colecoes = res.data
					if (this.colecoes && this.colecoes.length > 0) {
						this.totalItens = res.data[0].total
					}
				})
				.catch(err => console.log(err))
			this.inicial = true
			this.loadContent = false
		}
	}
}
</script>

<style lang="scss" scoped>
#colecoes {
	.search-box{
		background-color: $main-color;
		border-radius: 5px;
		padding: 20px 10px;
		margin-top: 20px;

		.filter {
			font-size: $font-size;
			color: #fff;
		}

		.section-box {
			display:flex;
			justify-content: space-between;

			.search-section {
				width:80%;
			}
			button {
				display: flex;
				justify-content: center;
				align-items: center;
				margin-top: 20px;
				height: 45px;
				width: 15%;
				padding: 0px;
				cursor: pointer;

				.txt {
					cursor:unset;
				}
			}
		}
	}
	.acoes {
		justify-content: center;
		display: flex;
		a {
			padding: 0;
			background-color: transparent;
		}
		button {
			background: #00243E  0% 0% no-repeat padding-box;
			height: 30px;
			display: flex;
			align-items: center;
			color: #fff;
			color: #fff;
			height: 30px;
			border-radius: 5px;
			opacity: 1;
			padding: 0 10px 0 10px;
		}
	}

	td {
		vertical-align: middle;
		font-size: .9em;
	}

	.not-found {
		margin-top: 50px;
		color: #000;
		text-align: center;
	}
}
</style>
